import { useQuery } from '@tanstack/react-query';
import useGlynt from '../useGlynt';
import { PackagerAttributes } from '../../../types/packager-types';

const useGetPackagerAttributes = (dataPoolId: string, packagerId: string) => {
  const glynt = useGlynt(dataPoolId);

  return useQuery({
    queryKey: ['packager', packagerId, 'attributes'],
    queryFn: async () => await (await glynt).packager.getAttributes(dataPoolId, packagerId),
    refetchOnWindowFocus: false
  });
};

export default useGetPackagerAttributes;
